// extracted by mini-css-extract-plugin
module.exports =  {"middleEllipsis":"MiddleEllipsis-module__middleEllipsis--z8","visible":"MiddleEllipsis-module__visible--W6","searchable":"MiddleEllipsis-module__searchable--YN"};